import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import { CONTAINER_TYPES } from '@src/quince-site-common/src/organisms/pageBuilder'
import { ProductSectionType } from '@src/quince-site-pdp/src/types/productPage.types'

import { MTE_ID } from '../constants'

export const DESKTOP_PRODUCT_IMAGES_AND_PURCHASE = {
  containerType: CONTAINER_TYPES.COLUMN,
  id: 'DESKTOP_PRODUCT_IMAGES_AND_PURCHASE',
  children: [
    {
      id: 'DESKTOP_PRODUCT_IMAGES',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.PRODUCT_IMAGES,
      },
    },
    {
      id: 'DESKTOP_PRODUCT_PURCHASE',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.PRODUCT_PURCHASE,
      },
    },
  ],
}

export const DESKTOP_PRODUCT_DETAILS_CARES_BRAND_COMPARISON_PAIR_WITH = {
  id: 'DESKTOP_PRODUCT_DETAILS_CARES_BRAND_COMPARISON_PAIR_WITH',
  containerType: CONTAINER_TYPES.COLUMN,
  children: [
    {
      id: 'DESKTOP_PRODUCT_DETAILS_AND_CARE',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.PRODUCT_DETAILS_AND_CARE,
      },
    },
    {
      id: 'DESKTOP_BRAND_COMPARISON',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.BRAND_COMPARISON,
      },
    },
    {
      id: 'DESKTOP_PAIR_WITH',
      containerType: CONTAINER_TYPES.SELF,
      props: {
        sectionType: ProductSectionType.PAIR_WITH,
      },
    },
  ],
}

export const DESKTOP_SIMILAR_PRODUCTS = {
  id: 'DESKTOP_SIMILAR_PRODUCTS',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.SIMILAR_PRODUCTS,
  },
}
export const DESKTOP_PRODUCT_REVIEWS = {
  id: 'DESKTOP_PRODUCT_REVIEWS',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.PRODUCT_REVIEWS,
  },
}
export const DESKTOP_TRANSPARENT_PRICING = {
  id: 'DESKTOP_TRANSPARENT_PRICING',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.TRANSPARENT_PRICING,
  },
}
export const DESKTOP_INFLUENCER = {
  id: 'DESKTOP_INFLUENCER',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.CUSTOM_SECTION,
    customSectionType: CUSTOM_SECTION_TYPE.INFLUENCER,
  },
}
export const DESKTOP_FBT = {
  id: 'DESKTOP_FBT',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.FREQUENTLY_BOUGHT_TOGETHER,
    mteId: MTE_ID,
  },
}
export const DESKTOP_FAQ = {
  id: 'DESKTOP_FAQ',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.CUSTOM_SECTION,
    customSectionType: CUSTOM_SECTION_TYPE.INFORMATION_BOXES,
  },
}
export const DESKTOP_YOU_MAY_ALSO_LIKE = {
  id: 'DESKTOP_YOU_MAY_ALSO_LIKE',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.YOU_MAY_ALSO_LIKE,
  },
}

export const DESKTOP_DISCLAIMER = {
  id: 'DESKTOP_DISCLAIMER',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.DISCLAIMER,
  },
}
